import { CheckIcon } from '@change/ds-icons';

import { Badge } from '@change/ds-core-ui/next';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { NormalizedDecisionMaker } from '../../../shared/types';

export const ResponseBadge: React.FC<{ response: NormalizedDecisionMaker['response'] }> = ({ response }) => {
	const { translate } = useI18n();

	return response?.message ? (
		<Badge
			label={translate('corgi.petition_gamma.decision_makers.response_status.responded')}
			variant="success"
			emphasis="weaker"
			className="w-fit"
			leadingIcon={<CheckIcon />}
		/>
	) : (
		<Badge
			label={translate('corgi.petition_gamma.decision_makers.response_status.not_responded')}
			variant="neutral"
			emphasis="weaker"
			className="w-fit"
		/>
	);
};
